import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

// Server times are UTC; tag untagged ISO timestamps so browsers show them in local time
const NAIVE_ISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/;
const tagUtc = (v) => {
  if (typeof v === "string") return NAIVE_ISO.test(v) ? `${v}Z` : v;
  if (Array.isArray(v)) return v.map(tagUtc);
  if (v && typeof v === "object" && Object.getPrototypeOf(v) === Object.prototype) {
    for (const k of Object.keys(v)) v[k] = tagUtc(v[k]);
  }
  return v;
};
api.interceptors.response.use((r) => { if (r.data && typeof r.data === "object" && !(r.data instanceof Blob)) tagUtc(r.data); return r; });

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => String(x.msg).replace(/^Value error, /, "")).join(", ");
  return fallback;
};

export const local = {
  get: (k, fallback) => {
    try {
      const v = localStorage.getItem(k);
      return v ? JSON.parse(v) : fallback;
    } catch {
      return fallback;
    }
  },
  set: (k, v) => localStorage.setItem(k, JSON.stringify(v)),
};

export async function downloadFile(path, filename, body) {
  const res = body ? await api.post(path, body, { responseType: "blob" }) : await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
